var getOverflowStates = function getOverflowStates(clientWidth, scrollLeft, scrollWidth) {
  var horizontalOverflow = scrollWidth > clientWidth;

  if (horizontalOverflow) {
    return [scrollLeft ? 1 : -1, scrollLeft + clientWidth !== scrollWidth ? 1 : -1];
  }

  return [0, 0];
};
var SCROLL_DISTANCE = 100;
var SCROLL_STEP = 20;
var SCROLL_SPEED = 10;
var scrollHorizontally = function scrollHorizontally(node, dir) {
  if (!node) return;
  var scrollAmount = 0;
  var slideTimer = setInterval(function () {
    node.scrollLeft += dir * SCROLL_STEP;
    scrollAmount += SCROLL_STEP;

    if (scrollAmount >= SCROLL_DISTANCE) {
      window.clearInterval(slideTimer);
    }
  }, SCROLL_SPEED);
};

export { getOverflowStates, scrollHorizontally };
